import { Button, Grid } from "@mui/material";
import useStyles from "../../../styles/styles";
import { InputField } from "../../../utils/FormFields";
import EquipmentTreatment from "./Forms/EquipmentTreatment";
import MedicationTreatment from "./Forms/MedicationTreatment";
import UploadField from "../../../utils/FormFields/UploadField";
import { FileBodyTypeEnum } from "../../../api/file-management";
import { Equipment, Medication } from "../../../api/medical-operations";

type Props = {
  equipment?: Equipment[];
  medications?: Medication[];
  type?: string;
  setType?: any;
};

const TreatmentForm = ({ medications, equipment, type, setType }: Props) => {
  const classes = useStyles();

  const availableMedication = medications?.map((medication: Medication) => {
    return {
      label: medication?.Name,
      value: medication?.MedicationID,
    };
  });

  const availableEquipment = equipment?.map((equipment: Equipment) => {
    return {
      label: equipment?.Name,
      value: equipment?.EquipmentID,
    };
  });

  return (
    <>
      <Grid container rowSpacing={4} spacing={2} sx={{ mt: 4, justifyContent: "center", alignContent: "center" }}>
        {type && type === "Equipment" && <EquipmentTreatment availableEquipment={availableEquipment} />}
        {type && type === "Medication" && <MedicationTreatment availableMedication={availableMedication} />}
        <Grid container />
        <Grid item xs={12} sm={2.5}>
          <UploadField
            name="PrescriptionImage"
            label="Prescription Image"
            fullWidth
            fileType={FileBodyTypeEnum.PRESCRIPTIONIMAGE}
          />
        </Grid>
        <Grid item xs={24} sm={10} md={3.5} key={"Category"}>
            <InputField
              name="ImageCategory"
              label="Category"              
              rows={1}
              fullWidth
              variant="filled"
            />
        </Grid>
        <Grid container />
      </Grid>
      <Grid className={classes.buttons}>
        <Grid className={classes.wrapper}>
          <Button type="submit" variant="contained" color="secondary" className={classes.button}>
            Add Patient Treatment
          </Button>
        </Grid>
      </Grid>
      <Grid />
    </>
  );
};

export default TreatmentForm;
